import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { AutoComplete, Form, Input, Modal, Select, message, Row, Col, Checkbox, DatePicker } from 'antd';
import HighSearchInput from '../../common/HighSearchInput';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import '../style.less';
import { actions } from './store';
import moment from 'moment';

const FormItem = Form.Item;
const Option = Select.Option;
const dateFormat = 'YYYY-MM-DD';
const phoneRegex = /^[0-1]\d{10}$/;
const emailRegex = /^([0-9A-Za-z\-_\.]+)@([0-9a-z]+\.[a-z]{2,3}(\.[a-z]{2})?)$/g;

class CreateForm extends Component {
    state = {
        disableMobile: false,
        disableCheckBox: false,
        showDepartSelect: true,
        isClearDepartment: false,
        CourtyardAreaList: [],
        needCourtyardArea: false, 
    }

    componentDidMount() {
        const { isEdit, form: { getFieldValue, getFieldDecorator } } = this.props;
        getFieldDecorator('userList', { initialValue: [] });
        if (!isEdit) {
            getFieldDecorator('hospital', { initialValue: [] });
            getFieldDecorator('department', { initialValue: [] });
            getFieldDecorator('hospitalName');
            getFieldDecorator('courtyardArea');
            getFieldDecorator('hospitalId');
            getFieldDecorator('hospitalDepartmentName');
            getFieldDecorator('courtyardArea');
            getFieldDecorator('hospitalId');
            getFieldDecorator('hospitalMainId');
        } else {
            getFieldDecorator('courtyardArea');
            getFieldDecorator('hospitalId');
            getFieldDecorator('hospitalDepartmentId');
            getFieldDecorator('courtyardArea');

            const userCompellation = getFieldValue('userCompellation');
            this.handleSearch(userCompellation);
        }
    }

    handleHighSearchInputChange = (id, options, idName, optionsName) => {
        const { isClearDepartment } = this.state;
        const { form: { setFieldsValue } } = this.props;
        const params = {};
        if(!isNaN(Number(id))){params[idName] = id !== '' ? id : '';}
        params[optionsName] = options;
        // 选中时同步设置对应的名称字段，避免 initValue 中 label 为空覆盖选中值
        const selected = (options || []).find(item => String(item.value) === String(id));
        if (idName === 'hospitalMainId') {
            if (selected) {
                params.hospitalName = selected.text;
            }
            // 不能在调用科室接口前清除
            params.courtyardArea = '';
            this.queryCourtyardAreaList(id);
            if (isClearDepartment) {
                params.department = [];
                params.hospitalDepartmentId = '';
                params.hospitalDepartmentName = '';
            }
            setFieldsValue({
                ...params,
            });
            this.setState({
                showDepartSelect: false,
                isClearDepartment: !isClearDepartment ? !!options.length : true,
            }, () => {
                this.setState({ showDepartSelect: true });
            });
        } else if (idName === 'hospitalDepartmentId') {
            if (selected) {
                params.hospitalDepartmentName = selected.text;
            }
            setFieldsValue({ ...params });
        } else {
            setFieldsValue({ ...params });
        }
    }

    queryCourtyardAreaList = (id) => {
            if(id && !isNaN(Number(id))){
                const options = {
                    method: 'POST',
                    url: API_URL.hospital.queryHospitalCourtyardAreaList,
                    data: {    
                        isSelfResponsible: 'DIRECTOR_USER',
                        hospitalMainId: id,
                    },
                    dataType: 'json',
                    doneResult: res => {
                        const { datas } = res;
                        let { needCourtyardArea } = this.state;
                        needCourtyardArea = false;
                        datas.map( i =>{
                            if(i.courtyardArea){
                                needCourtyardArea = true;
                            }
                        })
                        const { form: { setFieldsValue } } = this.props;
                        setFieldsValue({
                            hospitalId: datas[0].hospitalId
                        });
                        this.setState({ CourtyardAreaList: datas, needCourtyardArea });
                    }
                };
                $.sendRequest(options);
            }
    }

    handleCourtyardAreaChange = (value) => {
        const { form: { setFieldsValue } } = this.props;
        const { isClearDepartment } = this.state;
        const params = {};
        params.courtyardArea = value;
        params.hospitalId = value;
        if (isClearDepartment) {
            params.department = [];
            params.hospitalDepartmentId = '';
            params.hospitalDepartmentName = '';
        }
        setFieldsValue({
            ...params,
        });
        this.setState({
            showDepartSelect: false,
            isClearDepartment: !isClearDepartment ? !!options.length : true,
        }, () => {
            this.setState({ showDepartSelect: true });
        });
    }

    onGetPhone = (e) => {
        const { form: { setFieldsValue } } = this.props;
        if (e.target.checked) {
            this.setState({
                disableMobile: true,
                disableCheckBox: true,
            })
            setFieldsValue({ userMobile: '' });
            const options = {
                url: API_URL.user.getRandomUserMobile,
                data: {},
                dataType: 'json',
                doneResult: res => {
                    setFieldsValue({ userMobile: res.userMobile || '' });
                    this.setState({ disableCheckBox: false });
                },
                errorResult: () => {
                    this.setState({ disableCheckBox: false });
                }
            };
            $.sendRequest(options);
        } else {
            this.setState({ disableMobile: false });
            setFieldsValue({ userMobile: '' });
        }
    }

    handleSearch = (value) => {
        if (this.timer) {
            clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
            const { form: { getFieldValue, setFieldsValue } } = this.props;
            const hospitalId = getFieldValue('hospitalId');
            const departmentId = getFieldValue('hospitalDepartmentId');
            const userCompellation = getFieldValue('userCompellation');
            const options = {
                method: 'POST',
                url: API_URL.hospital.queryDoctorByParams,
                data: {
                    limit: 20,
                    hospitalId,
                    departmentId,
                    userCompellation,
                },
                dataType: 'json',
                doneResult: res => {
                    const { datas } = res;
                    setFieldsValue({ userList: datas });
                }
            };
            $.sendRequest(options);
        }, 300);
    }

    queryCourtyardAreaList = (id) => {
        this.timer = setTimeout(() => {
            if(id && !isNaN(Number(id))){
                const options = {
                    method: 'POST',
                    url: API_URL.hospital.queryHospitalCourtyardAreaList,
                    data: {    
                        hospitalMainId: id
                    },
                    dataType: 'json',
                    doneResult: res => {
                        const { datas } = res;
                        let { needCourtyardArea } = this.state;
                        needCourtyardArea = false;
                        datas.map( i =>{
                            if(i.courtyardArea){
                                needCourtyardArea = true;
                            }
                        })
                        const { form: { setFieldsValue } } = this.props;
                        setFieldsValue({
                            hospitalId: datas[0].hospitalId
                        });
                        this.setState({ CourtyardAreaList: datas, needCourtyardArea});
                    }
                };
                $.sendRequest(options);
            }
        }, 300);
    }

    render() {
        const { userId } = sessionStorage;
        const { isEdit, visible, form: { getFieldValue, getFieldDecorator } } = this.props;
        const { disableMobile, disableCheckBox, showDepartSelect, needCourtyardArea, CourtyardAreaList } = this.state;
        const hospitalMainId = getFieldValue('hospitalMainId');
        const courtyardArea = getFieldValue('courtyardArea');
        const hospitalId = getFieldValue('hospitalId');
        const hospitalName = getFieldValue('hospitalName');
        const hospitalDepartmentId = getFieldValue('hospitalDepartmentId');
        const hospitalDepartmentName = getFieldValue('hospitalDepartmentName');
        const hospital = getFieldValue('hospital') || [];
        const userList = getFieldValue('userList') || [];
        const departmentDisabled = hospital.some(i => i.value == hospitalId);
        const userOptions = userList.map(i => <Option key={String(i.userId)} disabled>{i.userCompellation}</Option>);
        const CourtyardAreaOptions = CourtyardAreaList.map(i => <Option key={i.hospitalId}>{i.courtyardArea}</Option>);
        const postStatus = getFieldValue('postStatus');
        const postStatusDisabled = postStatus === 'OFF';
        if (!isEdit) {
            return (
                <div className="create-form">
                    <Form onSubmit={this.submit}>
                        <div className="field-max">
                            <FormItem label="医院名称">
                                <HighSearchInput
                                    isEdit={true}
                                    keyword='hospitalName'
                                    style={{ width: 290 }}
                                    params={{ limit: 20, chargeUserId: userId, isSelfResponsible: 'DIRECTOR_USER' }}
                                    placeholder="输入医院名称检索"
                                    initValue={{ key: hospitalMainId, label: hospitalName }}
                                    url={API_URL.hospital.queryHospitalMainList}
                                    config={{ id: 'hospitalMainId', name: 'hospitalMainName' }}
                                    onChange={(id, options) => this.handleHighSearchInputChange(id, options, 'hospitalMainId', 'hospital')}
                                />
                                {
                                    getFieldDecorator('hospitalId', {
                                        rules: [
                                            { required: true, message: '医院名称不能为空' }
                                        ],
                                    })(
                                        <input style={{ display: 'none' }} />
                                    )
                                }
                            </FormItem>
                        </div>
                        <div className="field-max">
                            <FormItem label="院区名称">
                                <Select
                                    allowClear={true}
                                    onSearch={this.queryCourtyardAreaList}
                                    style={{ width: 290 }}
                                    placeholder="请输入"
                                    disabled={isEdit || !needCourtyardArea || !hospitalMainId } 
                                    value={courtyardArea}
                                    onChange={value => this.handleCourtyardAreaChange(value, 'courtyardArea')}
                                >
                                {CourtyardAreaOptions}
                                </Select>
                                {
                                getFieldDecorator('courtyardArea', {
                                    rules: [
                                        { required: false, message: '院区名称不能为空' }
                                    ],
                                })(
                                    <input style={{ display: 'none' }} />
                                )
                                }
                            </FormItem>
                        </div>
                        <div className="field-max">
                            <FormItem label="科室">
                                {
                                    showDepartSelect &&
                                    <HighSearchInput
                                        isEdit={true}
                                        keyword='hospitalDepName'
                                        style={{ width: 290 }}
                                        disabled={!needCourtyardArea ? !hospitalMainId : !courtyardArea}
                                        params={{ limit: 20, hospitalId: hospitalId ? hospitalId : null }}
                                        placeholder="输入科室名称检索"
                                        initValue={{ key: hospitalDepartmentId, label: hospitalDepartmentName }}
                                        url={API_URL.hospital.queryDepWhenAddDoctor}
                                        config={{ id: 'hospitalDepartmentId', name: 'departmentLocalName' }}
                                        onChange={(id, options) => this.handleHighSearchInputChange(id, options, 'hospitalDepartmentId', 'department')}
                                    />
                                }
                                {
                                    getFieldDecorator('hospitalDepartmentId', {
                                        rules: [
                                            { required: true, message: '科室不能为空' }
                                        ],
                                    })(
                                        <input style={{ display: 'none' }} />
                                    )
                                }
                            </FormItem>
                        </div>
                        <div className="field-max">
                            <FormItem label="医生姓名">
                                {
                                    visible &&
                                    getFieldDecorator('userCompellation', {
                                        rules: [
                                            { required: true, message: '医生姓名不能为空' }
                                        ]
                                    })(
                                        <AutoComplete
                                            onSearch={this.handleSearch}
                                            placeholder="请输入"
                                            style={{ width: 290 }}
                                            disabled={!hospitalId || !hospitalDepartmentId}
                                        >
                                            {userOptions}
                                        </AutoComplete>
                                    )
                                }
                            </FormItem>
                        </div>
                        <div className="field-max" style={{ display: 'none' }}>
                            <FormItem label="用户ID">
                                {
                                    getFieldDecorator('userId')(<Input display />)
                                }
                            </FormItem>
                        </div>
                        <div className="field-max">
                            <FormItem label="性别">
                                {
                                    getFieldDecorator('gender', {
                                        rules: [
                                            { required: true, message: '性别不能为空' }
                                        ],
                                    })(
                                        <Select style={{ width: 80 }} placeholder="请选择">
                                            <Option value="MALE">男</Option>
                                            <Option value="FEMALE">女</Option>
                                        </Select >
                                    )
                                }
                            </FormItem>
                        </div>
                        <div className="field-max">
                            <FormItem label="在岗状态">
                                {
                                    getFieldDecorator('postStatus', {
                                        initialValue: 'ON',
                                    })(
                                        <Select style={{ width: 120 }} placeholder="请选择" disabled={postStatusDisabled}>
                                            <Option value="ON">在岗</Option>
                                            <Option value="RETIRED">退休</Option>
                                            <Option value="LEFT">离职</Option>
                                            <Option value="DECEASED">离世</Option>
                                            {isEdit && postStatus === 'OFF' && <Option value="OFF">已转岗</Option>}
                                        </Select >
                                    )
                                }
                            </FormItem>
                        </div>
                        <div className="field-max">
                            <FormItem label="出生日期">
                                {
                                    getFieldDecorator('birthDate')(
                                        <DatePicker style={{ width: 120 }} placeholder="请选择" />
                                    )
                                }
                            </FormItem>
                        </div>
                        <div className="field-max">
                            <FormItem label="专业技术职称">
                                {
                                    getFieldDecorator('professionalTitle')(
                                        <Select style={{ width: 120 }} placeholder="请选择">
                                            <Option value="正高级">正高级</Option>
                                            <Option value="副高级">副高级</Option>
                                            <Option value="中级">中级</Option>
                                            <Option value="初级">初级</Option>
                                            <Option value="其他">其他</Option>
                                        </Select >
                                    )
                                }
                            </FormItem>
                        </div>
                        <div className="field-max">
                            <FormItem label="职务">
                                {
                                    getFieldDecorator('doctorPosition', {
                                        rules: [
                                            { required: true, message: '职务不能为空' }
                                        ]
                                    })(<Input placeholder="请输入" />)
                                }
                            </FormItem>
                        </div>
                        <div className="field-max">
                            <FormItem label="手机号码">
                                {
                                    getFieldDecorator('userMobile', {
                                        rules: [
                                            { required: true, message: '手机号不能为空' },
                                            !disableMobile && { pattern: phoneRegex, message: '请填写正确的手机号码！' },
                                        ]
                                    })(<Input disabled={disableMobile} maxLength={disableMobile} placeholder="请输入" />)
                                }
                            </FormItem>
                        </div>
                        <Row style={{ marginTop: "-6px" }}>
                            <Col span={7} style={{ textAlign: "right", paddingRight: "13px" }}></Col>
                            <Col span={15} style={{ whiteSpace: "normal", wordBreak: "break-all" }}>
                                <Checkbox disabled={disableCheckBox} checked={disableMobile} onChange={this.onGetPhone}>若无手机号，请勾选此项，系统会自动填充000开头11位数字作为标识</Checkbox>
                            </Col>
                        </Row>
                        <div className="field-max">
                            <FormItem label="固定电话">
                                {
                                    getFieldDecorator('userTelphone')(<Input placeholder="请输入" />)
                                }
                            </FormItem>
                        </div>
                        <div className="field-max">
                            <FormItem label="邮箱">
                                {
                                    getFieldDecorator('userEmail', {
                                        rules: [
                                            { pattern: emailRegex, message: '请填写正确的邮箱！' },
                                        ]
                                    })(<Input placeholder="请输入" />)
                                }
                            </FormItem>
                        </div>
                        <div className="field-max">
                            <FormItem label="接待时间">
                                {
                                    getFieldDecorator('receptionTime')(<Input placeholder="请输入" />)
                                }
                            </FormItem>
                        </div>
                        <div className="field-max">
                            <FormItem label="接待地点">
                                {
                                    getFieldDecorator('receptionPlace')(<Input placeholder="请输入" />)
                                }
                            </FormItem>
                        </div>
                    </Form>
                </div>
            );
        } else {
            return (
                <div className="create-form">
                    <Form>
                        <div className="field-max">
                            <FormItem label="医院名称">
                                {
                                    getFieldDecorator('hospitalName', {
                                        rules: [
                                            { required: true, message: '' }
                                        ]
                                    })(<Input disabled />)
                                }
                            </FormItem>
                        </div>
                        <div className="field-max">
                            <FormItem label="科室">
                                {
                                    getFieldDecorator('departmentLocalName', {
                                        rules: [
                                            { required: true, message: '' }
                                        ]
                                    })(
                                        <Input disabled />
                                    )
                                }
                            </FormItem>
                        </div>
                        <div className="field-max" style={{ display: 'none' }}>
                            <FormItem label="用户ID">
                                {
                                    getFieldDecorator('userId')(<Input display />)
                                }
                            </FormItem>
                        </div>
                        <div className="field-max">
                            <FormItem label="医生姓名">
                                {
                                    visible &&
                                    getFieldDecorator('userCompellation', {
                                        rules: [
                                            { required: true, message: '医生姓名不能为空' }
                                        ]
                                    })(
                                        <AutoComplete
                                            onSearch={this.handleSearch}
                                            placeholder="请输入"
                                            style={{ width: 290 }}
                                            disabled={!hospitalId || !hospitalDepartmentId}
                                        >
                                            {userOptions}
                                        </AutoComplete>
                                    )
                                }
                            </FormItem>
                        </div>
                        <div className="field-max">
                            <FormItem label="性别">
                                {
                                    getFieldDecorator('gender', {
                                        rules: [
                                            { required: true, message: '性别不能为空' }
                                        ]
                                    })(
                                        <Select style={{ width: 80 }} placeholder="请选择">
                                            <Option value="MALE">男</Option>
                                            <Option value="FEMALE">女</Option>
                                        </Select >
                                    )
                                }
                            </FormItem>
                        </div>
                        <div className="field-max">
                            <FormItem label="在岗状态">
                                {
                                    getFieldDecorator('postStatus')(
                                        <Select style={{ width: 120 }} placeholder="请选择" disabled={postStatusDisabled}>
                                            <Option value="ON">在岗</Option>
                                            <Option value="RETIRED">退休</Option>
                                            <Option value="LEFT">离职</Option>
                                            <Option value="DECEASED">离世</Option>
                                            {isEdit && postStatus === 'OFF' && <Option value="OFF">已转岗</Option>}
                                        </Select >
                                    )
                                }
                            </FormItem>
                        </div>
                        <div className="field-max">
                            <FormItem label="出生日期">
                                {
                                    getFieldDecorator('birthDate')(
                                        <DatePicker style={{ width: 120 }} placeholder="请选择" />
                                    )
                                }
                            </FormItem>
                        </div>
                        <div className="field-max">
                            <FormItem label="专业技术职称">
                                {
                                    getFieldDecorator('professionalTitle')(
                                        <Select style={{ width: 120 }} placeholder="请选择">
                                            <Option value="正高级">正高级</Option>
                                            <Option value="副高级">副高级</Option>
                                            <Option value="中级">中级</Option>
                                            <Option value="初级">初级</Option>
                                            <Option value="其他">其他</Option>
                                        </Select >
                                    )
                                }
                            </FormItem>
                        </div>
                        <div className="field-max">
                            <FormItem label="职务">
                                {
                                    getFieldDecorator('doctorPosition', {
                                        rules: [
                                            { required: true, message: '职务不能为空' }
                                        ]
                                    })(<Input placeholder="请输入" />)
                                }
                            </FormItem>
                        </div>
                        <div className="field-max">
                            <FormItem label="手机号码">
                                {
                                    getFieldDecorator('userMobile', {
                                        rules: [
                                            { required: true, message: '手机号码不能为空' },
                                            { pattern: phoneRegex, message: '请填写正确的手机号码！' },
                                        ]
                                    })(<Input maxLength="11" placeholder="请输入" />)
                                }
                            </FormItem>
                        </div>
                        <div className="field-max">
                            <FormItem label="固定电话">
                                {
                                    getFieldDecorator('userTelphone')(<Input placeholder="请输入" />)
                                }
                            </FormItem>
                        </div>
                        <div className="field-max">
                            <FormItem label="邮箱">
                                {
                                    getFieldDecorator('userEmail', {
                                        rules: [
                                            { pattern: emailRegex, message: '请填写正确的邮箱！' },
                                        ]
                                    })(<Input placeholder="请输入" />)
                                }
                            </FormItem>
                        </div>
                        <div className="field-max">
                            <FormItem label="接待时间">
                                {
                                    getFieldDecorator('receptionTime')(<Input placeholder="请输入" />)
                                }
                            </FormItem>
                        </div>
                        <div className="field-max">
                            <FormItem label="接待地点">
                                {
                                    getFieldDecorator('receptionPlace')(<Input placeholder="请输入" />)
                                }
                            </FormItem>
                        </div>
                    </Form>
                </div>
            );
        }

    }
}

class UpdateDoctor extends Component {
    state = {
        visible: false,
        confirmLoading: false,
        isEdit: false,
    }

    hide = () => {
        this.props.showUpdate(false);
        this.props.updateDoctor({});
    }

    componentWillReceiveProps(nextProps) {
        const { record, visible } = nextProps;
        if (!this.props.visible && visible) {
            this.setState({ isEdit: !!Object.keys(record).length });
        }
    }

    // 校验value是否存在，且是options中的一项
    validateValueInOptions = (value, name, list) => {
        if (value) {
            const isExist = list.some(item => item.value == value);
            if (!isExist) {
                message.warning(`请选择正确的${name}`);
                return true;
            }
        } else {
            message.warning(`请选择${name}`);
            return true;
        }
        return false;
    }

    handleSubmit = () => {
        this.refs.form.validateFieldsAndScroll((errors, values) => {
            if (errors) {
                return;
            }
            const { isEdit } = this.state;
            const { department, hospitalDepartmentId, hospital, hospitalId, birthDate, hospitalMainId } = values;
            if (!isEdit) {
                if (this.validateValueInOptions(hospitalDepartmentId, '科室', department)) {
                    return;
                }
                if (this.validateValueInOptions(hospitalMainId, '医院名称', hospital)) {
                    return;
                }
            }

            this.setState({ confirmLoading: true });

            const { text: hospitalName } = (hospital || []).find(i => i.value == hospitalId) || {};
            values.hospitalName = hospitalName;
            const { text: hospitalDepartmentName } = (department || []).find(i => i.value == hospitalDepartmentId) || {};
            values.hospitalDepartmentName = hospitalDepartmentName;
            this.props.updateDoctor(values);
            
            const params = {};
            if (birthDate) {
                params.birthDate = moment(birthDate).format(dateFormat);
            }

            this.save({ ...values, ...params }, true);
        });
    }

    save = (params, isCheck) => {
        const { isEdit } = this.state;
        const url = isEdit ? API_URL.hospital.editDoctor : API_URL.hospital.addDoctor;
        this.setState({ confirmLoading: true });
        const options = {
            method: 'POST',
            url,
            data: {
                ...params,
                isCheck,
                enterpriseId: 1,
                hospital: null,
                department: null,
            },
            dataType: 'json',
            doneResult: res => {
                if (res.info) {
                    Modal.confirm({
                        iconType: 'question-circle',
                        title: res.info,
                        onOk: () => this.save(params, false),
                        okText: '继续添加',
                        onCancel: () => {
                            const { hospitalName, userCompellation } = params;
                            this.props.saveSearchParams({
                                hospitalName,
                                userCompellation,
                            });
                            this.setState({ confirmLoading: false });
                            this.hide();
                        },
                        cancelText: '更新信息',
                    });
                    return;
                }
                message.success(res.success);
                this.setState({ confirmLoading: false }, () => {
                    this.hide();
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ confirmLoading: false });
            }
        };
        $.sendRequest(options);
    }

    render() {
        const { record, visible, updateDoctor } = this.props;
        const { confirmLoading, isEdit } = this.state;
        const obj = {};
        const data = { ...record, ...updateDoctor };
        data.birthDate = data.birthDate ? moment(data.birthDate) : null;
        for (let [key, value] of Object.entries(data)) {
            obj[key] = { value };
        }
        const mapPropsToFields = () => obj;

        CreateForm = Form.create({ mapPropsToFields })(CreateForm);
        return (
            <Modal
                title={isEdit ? '修改医生' : '添加医生'}
                visible={visible}
                onOk={this.handleSubmit}
                onCancel={this.hide}
                className="create-modal"
                wrapClassName="vertical-center-modal"
                width="450px"
                maskClosable={false}
                confirmLoading={confirmLoading}
            >
                <CreateForm ref="form" isEdit={isEdit} visible={visible} />
            </Modal>
        );
    }
}

const mapStateToProps = (state) => {
    const { hospitalState: { doctorInfoState } } = state;
    const { updateDoctor } = doctorInfoState;
    return {
        updateDoctor,
    }
}

export default connect(mapStateToProps, actions)(UpdateDoctor);


// WEBPACK FOOTER //
// ./src/components/hospital/doctorInfo/UpdateDoctor.js